import React, { useRef } from 'react';
import { X } from 'lucide-react';
import styles from './UrlInput.module.css';

export interface UrlInputProps {
  id: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement> | string) => void;
  label?: string; // Resa opzionale
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  inputClassName?: string;
  showClearButton?: boolean;
}

const UrlInput: React.FC<UrlInputProps> = ({
  id,
  value,
  onChange,
  label,
  placeholder,
  disabled = false,
  className = '',
  inputClassName = '',
  showClearButton = true,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
  };

  const handleClear = () => {
    onChange('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const isClearButtonVisible = showClearButton && value && !disabled;

  return (
    <div className={`${styles.urlInputContainer} ${className}`}>
      {label && ( // Renderizza la label solo se fornita
        <label htmlFor={id} className="input-label">
          {label}
        </label>
      )}
      <div className={styles.inputWrapper}>
        <input
          ref={inputRef}
          type="url"
          id={id}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          className={`${styles.inputField} ${isClearButtonVisible ? styles.inputWithClear : ''} ${inputClassName}`}
        />
        {isClearButtonVisible && (
          <button
            type="button"
            onClick={handleClear}
            className={styles.clearButton}
            aria-label="Clear input"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default UrlInput;